<template>
    <div v-if="ready && banner" class="visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(slide, index) in banner.slides.filter((slide) => slide.image)" :key="index" class="swiper-slide">
                    <a class="visual__image" href="">
                        <picture>
                            <!-- 모바일 배너 -->
                            <source :srcset="slide.image" media="(max-width:768px)" />
                            <!-- pc 배너 -->
                            <img :src="slide.image" alt="" />
                        </picture>
                    </a>
                </div>
            </div>
        </div>
        <div class="visual__prev"></div>
        <div class="visual__next"></div>
        <div class="visual__pagination visual__pagination--bullet"></div>
    </div>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";

export default {
    props: {
        code: { type: String, default: null },
        pc: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false },
    },
    data: () => {
        return {
            detect,
            ready: false,
            banner: null,
        };
    },
    mounted() {
        if ((this.detect == "pc" && this.pc) || (this.detect == "mobile" && this.mobile)) this.init();
    },
    methods: {
        async init() {
            try {
                var { banner } = await api.v1.banners.getBanner({ code: this.code });
                this.banner = banner;
                this.ready = true;
                this.render();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        render() {
            this.$nextTick(() => {
                // 비주얼 슬라이드
                var slideVisual = new Swiper(".visual .swiper-container", {
                    centeredSlides: true,
                    spaceBetween: 0,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    pagination: {
                        el: ".visual__pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".visual__next",
                        prevEl: ".visual__prev",
                    },
                });
            });
        },
    },
};
</script>
